import { AnimatePresence, motion } from "motion/react";
import { useMemo } from "react";

import styled from "styled-components/macro";
import theme from "theme";

import FnrIcon from "UI/FnrIcon";
import FnrTypography from "UI/FnrTypography";

import { useIsSearchHitByGroupID } from "./NetworkGroups/stateHooks";
import {
  useDebouncedSearchValue,
  useSearchValue,
} from "./groupsCommunicationStore";

export default function NoSearchMatches() {
  const searchValue = useSearchValue();
  const debouncedSearchValue = useDebouncedSearchValue();
  const isSearchHitByGroupID = useIsSearchHitByGroupID();

  /** @type {boolean} */
  const shouldShow = useMemo(
    () =>
      searchValue.length > 0 &&
      !Object.values(isSearchHitByGroupID).includes(true),
    [isSearchHitByGroupID, searchValue.length]
  );

  return (
    <AnimatePresence>
      {shouldShow && (
        <Wrapper
          data-cy="NavBar_NoSearchMatches"
          initial={{ opacity: 0, y: -10 }}
          animate={{ opacity: 1, y: 0 }}
          // exit animation intentionally omitted
          transition={{ duration: 0.1 }}
        >
          <IconWrapper>
            {/* apart from just re-using fa-magnifying-glass, */}
            {/* we could try one of the following: */}
            {/* far fa-magnifying-glass-minus */}
            {/* far fa-magnifying-glass-arrows-rotate */}
            {/* far fa-filter-slash */}
            {/* far fa-align-slash */}
            {/* far fa-filter-circle-xmark */}
            {/* far fa-empty-set */}
            {/* fal fa-face-thinking */}
            <FnrIcon far fa-folder-open shadow />
          </IconWrapper>
          <FnrTypography color="textLight" shadow italic>
            No groups matched{" "}
            <SearchValueWrapper>{debouncedSearchValue}</SearchValueWrapper>
          </FnrTypography>
        </Wrapper>
      )}
    </AnimatePresence>
  );
}

const Wrapper = styled(motion.div)`
  text-align: center;
  scroll-margin-top: 40px;
`;

const IconWrapper = styled.div`
  font-size: 1.75rem;
  color: ${theme.colors.textLight};
  // hand-adjusted to be vertically centered
  padding-top: 2rem;
`;

const SearchValueWrapper = styled.span`
  font-style: normal;
  font-weight: bold;
`;
